const CourseProviderManagement = () =>
  import("./views/CourseProviderManagement.vue");

const Courses = () => import("@/admin/course/views/Courses.vue");
const AdminCoursesAddEdit = () =>
  import("@/admin/course/views/CourseAddEdit.vue");

export const courseAdminRoutes = [
  {
    path: "/admin/courses/edit/:id?",
    name: "AdminCoursesAddEdit",
    component: AdminCoursesAddEdit,
    props: true,
  },
  {
    path: "/admin/courses",
    name: "AdminCourses",
    component: Courses,
  },
  {
    path: "/admin/courses-provider",
    name: "AdminCourseProvider",
    component: CourseProviderManagement,
  },
];
